import React from 'react';
// import SearchInput from '../../components/base/search-input';
import { IoIosNotificationsOutline } from 'react-icons/io';
import { useAuthStore } from '../../store';
import BaseAvatar from '../../components/base/avatar';

function HeaderComponent() {
  // Load the auth state from local storage
  const { loadAuthStateFromStorage } = useAuthStore();
  const authState = loadAuthStateFromStorage();
  const firstName = authState?.userFullName.split(' ')[0];

  return (
    <header className="h-[72px] bg-white flex items-center justify-between px-12">
      <span className="text-primary font-semibold">
        Today’s Rate - 1 USD = ₦1,550
      </span>

      <div className="flex items-center">
        <span className="mr-4 text-[#123960] text-sm">
          Hello, {firstName} 👋
        </span>
        <BaseAvatar label={firstName} />
        <div className="border-l border-[#54555A] ml-4 pl-3">
          <IoIosNotificationsOutline size={26} />
        </div>
      </div>
    </header>
  );
}

export default HeaderComponent;
